import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { useAuthStore } from '@/store';

const APPOINTMENT_URL =
  import.meta.env.VITE_APPOINTMENT_URL ||
  'https://ibujmw0ka7.execute-api.us-east-1.amazonaws.com/appointment';

const appointmentHttpLink = new HttpLink({
  uri: APPOINTMENT_URL,
  fetch: (uri, options) => {
    const accessToken = useAuthStore.getState().accessToken;
    const headers = new Headers(options?.headers);
    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }
    return fetch(uri, { ...options, headers });
  },
});

/** Authenticated appointment client */
export const appointmentClient = new ApolloClient({
  link: appointmentHttpLink,
  cache: new InMemoryCache(),
});

/** Public appointment client — no auth, for guest bookings + public queries */
export const publicAppointmentClient = new ApolloClient({
  link: new HttpLink({ uri: APPOINTMENT_URL }),
  cache: new InMemoryCache(),
});
